import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=1b321054&"
import script from "./editProfile.vue?vue&type=script&lang=js&"
export * from "./editProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports